<template>
    <v-container fluid grid-list-md>
        <audits></audits>
    </v-container>
</template>
<script>
import Audits from '../components/Auditing/List.vue';

export default {
    components: {
        Audits
    }
};
</script>
